import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

interface TicketChange {
    field: string;
    oldValue: string;
    newValue: string;
}

interface TicketHistoryItem {
    historyId: number;
    updatedBy: string;
    updatedAt: string;
    changes: TicketChange[];
}

interface Iprops {
    singleData: any;
    toast: any;
    reloadData: () => void;
    hasPermission: (pageName: string, featureName?: string) => boolean;
}

export const TicketHistory = (props: Iprops) => {
    const [history, setHistory] = useState<TicketHistoryItem[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [expandedRows, setExpandedRows] = useState<any>({});
    const [previewVisible, setPreviewVisible] = useState(false);
    const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null);

    // Utility to strip HTML tags and get plain text
    const stripHtmlTags = (htmlString: string) => {
        if (!htmlString) return "";
        const div = document.createElement("div");
        div.innerHTML = htmlString;
        return div.textContent || div.innerText || "";
    };
    const handlePreviewImage = async (fileName: string) => {
        try {
            const token = JSON.parse(sessionStorage.getItem("auth") || "")?.token;

            const res = await fetch(`${baseUrl}Support/NoteFile/${fileName}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            if (!res.ok) throw new Error("Failed to fetch image");

            const blob = await res.blob();

            if (blob.size === 0) {
                setImagePreviewUrl(null);
                setPreviewVisible(false);
                return;
            }

            const objectUrl = URL.createObjectURL(blob);
            setImagePreviewUrl(objectUrl);
            setPreviewVisible(true);

        } catch (error) {
            console.error("Image preview error:", error);
            setImagePreviewUrl(null);
            setPreviewVisible(false);
        }
    };


    const onDialogHide = () => {
        setPreviewVisible(false);
        if (imagePreviewUrl) {
            URL.revokeObjectURL(imagePreviewUrl);
            setImagePreviewUrl(null);
        }
    };

    const loadTableData = async () => {
        if (!props.singleData) return;
        const ticketIdParam =
            props.singleData.ticket_Number ??
            props.singleData.ticket_Id ??
            props.singleData.ticketNumber;
        if (!ticketIdParam) return;

        setLoading(true);
        const response = await Fetch(
            "Support/getTicketHistory",
            "GET",
            null,
            `ticket_Id=${ticketIdParam}`,
            props.toast
        );
        if (response) {
            try {
                const payload = await response.json();
                if (Array.isArray(payload)) {
                    setHistory(payload);
                } else if (payload.result) {
                    setHistory(payload.result);
                } else {
                    setHistory(payload || []);
                }
            } catch {
                setHistory([]);
            }
        }
        setLoading(false);
    };

    useEffect(() => {
        loadTableData();
    }, [props.singleData?.ticket_Number]);
    const changesTemplate = (rowData: TicketHistoryItem) => {
        return (
            <div style={{ paddingLeft: 8 }}>
                {rowData.changes?.length ? (
                    <ul style={{ margin: 0, paddingLeft: 16 }}>
                        {rowData.changes.map((c, i) => (
                            <li key={i} style={{ marginBottom: "6px" }}>
                                <strong>{c.field}</strong>:{" "}
                                {c.field.toLowerCase() === "attachment" ? (
                                    <Button
                                        type="button"
                                        icon="pi pi-eye"
                                        onClick={() => handlePreviewImage(c.newValue)}
                                        className="p-button-success p-button-text p-0"
                                        title="Preview Attachment"
                                    />
                                ) : ["desc", "description", "note"].includes(c.field.toLowerCase()) ? (
                                    <>
                                        {stripHtmlTags(c.oldValue)} → {stripHtmlTags(c.newValue)}
                                    </>
                                ) : (
                                    <>
                                        {c.oldValue} → {c.newValue}
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <div style={{ fontStyle: "italic" }}>No changes recorded</div>
                )}
            </div>
        );
    };

    return (
        <>
            <div
                style={{
                    width: "100%",
                    padding: 0,
                    margin: 0,
                    backgroundColor: "#f6fdf8",
                    border: "1px solid #cce3d0",
                    borderRadius: 0,
                }}
            >
                <DataTable className="grey-teal-table" style={{ width: "100%", background: "white", borderRadius: 0, }}
                    size="small"
                    stripedRows
                    showGridlines
                    scrollHeight="50vh"
                    responsiveLayout="scroll"
                    value={history}
                    loading={loading}
                    dataKey="historyId"
                    expandedRows={expandedRows}
                    onRowExpand={(e) => setExpandedRows({ [e.data.historyId]: true })}
                    onRowCollapse={() => setExpandedRows({})}
                    rowExpansionTemplate={changesTemplate}
                >
                    <Column expander style={{ width: "100%" }} />
                    <Column field="updatedBy" header="Updated By" />
                    <Column field="updatedAt" header="Updated At" />
                </DataTable>
            </div>

            <Dialog header="Image Preview" visible={previewVisible} style={{ width: "50vw" }} modal onHide={onDialogHide} >
                {imagePreviewUrl ? (
                    <img src={imagePreviewUrl} alt="Preview" style={{ width: "100%", borderRadius: "6px" }} />
                ) : (
                    <p>No preview available</p>
                )}
            </Dialog>
        </>
    );
};
